import React from 'react';
import { Button, makeStyles } from '@fluentui/react-components';
import {
  Skeleton,
  SkeletonItem,
} from '@fluentui/react-skeleton';

const useStyles = makeStyles({
  resultWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: '36px',
    gap: '24px',
  },
  cardWrapper: {
    backgroundColor: '#fff',
    width: '358px',
    height: '164px',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '12px',
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '12px',
  },
  headerTitle: {
    width: '183px',
  },
  headerSubTitle: {
    width: '100px',
    marginTop: '12px',
  },
  footerRow: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px',
    marginTop: '24px',
  },
  footerDescription: {
    width: '100%',
  },
  footerButton: {
    marginTop: '12px',
    width: 'fit-content',
  },
});

const AdvertiserResultShimmer = () => {
  const classes = useStyles();
  return (
    <div className={classes.cardWrapper}>
      <Skeleton animation="wave">
        <div className={classes.headerRow}>
          <SkeletonItem shape="circle" size={36} />
          <div className={classes.headerText}>
            <SkeletonItem className={classes.headerTitle} shape="square" size={12} />
            <SkeletonItem className={classes.headerSubTitle} shape="square" size={12} />
          </div>
        </div>
        <div className={classes.footerRow}>
          <SkeletonItem className={classes.footerDescription} shape="square" size={12} />
          <Button className={classes.footerButton} appearance="primary" disabled disabledFocusable>
            See all ads
          </Button>
        </div>
      </Skeleton>
    </div>
  );
};

const AdvertiserResultLoadingEffectComponent = () => {
  const classes = useStyles();
  const adResultShimmers = [...Array(12)].map((_, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <AdvertiserResultShimmer key={index} />
  ));

  return (
    <div className={classes.resultWrapper}>
      { adResultShimmers }
    </div>
  );
};

export const AdvertiserResultLoadingEffect = AdvertiserResultLoadingEffectComponent;
